import * as immer from 'immer';
import _ from 'lodash';
import React, { useState } from 'react';
import ReactTags from 'react-tag-autocomplete';
import api from 'services';

export default function LinksTags({ tags, setTags, placeHolder = 'Search by tag' }) {
    const [suggestions, setSuggestions] = useState([]);

    const handleDeleteTag = (index) => {
        const tagsCopy = _.cloneDeep(tags);
        tagsCopy.splice(index, 1);
        setTags(tagsCopy);
    };

    const handleAddition = (tag) => {
        const newTags = immer.produce(tags, (draftTags) => {
            if (!draftTags.some(dt => dt.name === tag.name)) {
                draftTags.push(tag);
            }
        });
        
        setTags(newTags);
    };

    const handleInputChange = (searchText) => {
        if (searchText.length < 2) {
            return;
        }

        api.findAnalyticsTags(searchText)
            .then((response) => {
                setSuggestions(response.data.map((s) => {
                    return { ...s, name: s.value };
                }));
            });
    };

    return (
        <ReactTags
            allowNew
            autofocus={false}
            tags={tags}
            suggestions={suggestions}
            handleDelete={handleDeleteTag}
            handleAddition={handleAddition}
            handleInputChange={handleInputChange}
            placeholder={placeHolder}
            suggestionComponent={SuggestionComponent}
        />
    );
}

function SuggestionComponent({ item, query }) {
    return (
        <span 
            id={item.id} 
            className={item.name === query ? 'match' : 'no-match'}
        >
            {item.name}
        </span>
    );
}



// WEBPACK FOOTER //
// ./app/components/Analytics/LinksTags.jsx